export enum VoiceDesignerGender {
  MALE = 'male',
  FEMALE = 'female'
}

export enum VoiceDesignerStyleEnum {
  POP = 'Pop',
  ROCK = 'Rock',
  RAP = 'Rap',
  RNB = 'R&B',
  TRADITIONAL = 'Traditional',
  LATIN = 'Latin'
}
